class Testimonials {
  constructor() {
    this.initSlick();
  }

  initSlick() {
    $('.testimonials__slider').slick({
      centerMode: true,
      centerPadding: '20px',
      slidesToShow: 1,
      dots: true,
      arrows: false,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
    });
  }
}

const testimonials = new Testimonials();